'use client';

import { useIntersectionObserver } from '@bb/lib/utils/hooks/useIntersectionObserver';
import type { Map as IMap } from '@bb/sanity.types';
import { Suspense, lazy, useRef } from 'react';
import { SanityWrapper, Title } from '../SanityWrapper';

// lazy load the map
const LeagueMapContainer = lazy(
  () => import('@bb/components/LeagueMap/LeagueMapContainer')
);

const Loading = () => {
  return (
    <div className="title flex h-[35rem] w-full items-center justify-between rounded-md bg-gray-100 text-gray-400 text-lg">
      <div className="my-[1%] ml-[8px] hidden h-[96%] w-96 items-center justify-center rounded-md bg-gray-200/50 md:flex" />

      <div className="flex h-full w-[calc(100%-8px-24rem)] animate-pulse items-center justify-center">
        Loading...
      </div>
    </div>
  );
};

export function SanityMap(props: { block: IMap }) {
  const mapSection = useRef<HTMLDivElement>(null);
  const isVisible = useIntersectionObserver(mapSection);

  return (
    <SanityWrapper className="w-full flex-col items-center" ref={mapSection}>
      <Title title={props.block.title?.toUpperCase()} />
      {isVisible && (
        <Suspense fallback={<Loading />}>
          <LeagueMapContainer
            startingCoords={
              props.block.location
                ? {
                    lat: props.block.location.lat!,
                    lng: props.block.location.lng!,
                  }
                : undefined
            }
            startingZoom={10}
          />
        </Suspense>
      )}
    </SanityWrapper>
  );
}
